'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
var $d_Lcom_raquo_airstream_core_Observer = new $j_java$002elang$002e$002dObject.$TypeData().i(1, "com.raquo.airstream.core.Observer", ({
  bH: 1,
  aP: 1,
  M: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer as $d_Lcom_raquo_airstream_core_Observer };
